export const UTILITY_BILLS_ABSOLUTE_PATH = "/documents/summary";

export const UTILITY_BILL_PAGE = {
  ABSOLUTE_PATH: (billId: string) => `/documents/summary/${billId}`,
  PATH: ":billId",
  KEY: "billId",
} as const;
